<template>
    <div class="order-detail">
        <div class="bread-crumbs">
            <div class="bread-crumbs-item" @click="onOrderListClick">订单列表</div>
            <Icon type="ios-arrow-forward" size="14" />
            <div class="bread-crumbs-item active">订单详情</div>
        </div>
        <div class="order-info">
            <div class="order-step-box">
                <div class="order-step-info">
                    <div class="order-step-item" v-for="(item,index) in steps" :key="index">
                        <div :class="['line',{'active':item.line_active}]" v-if="index != 0"></div>
                        <div class="dot-info-box">
                            <div :class="['dot',{'active':item.dot_active}]"></div>
                            <div class="title">{{ item.title }}</div>
                            <div v-if="item.time" class="time">{{ item.time }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="order-status-box">
                <div class="status-text">
                    <div class="label">当前订单状态:</div>
                    <div class="value">{{detail.status_name}}</div>
                    <div v-if="detail.status_text === 'service' && activeService" class="service-btn" @click="onServiceDetail">售后详情</div>
                </div>
                <div class="btn-box">
                    <div v-if="detail.status_text === 'wait_pay' && false" class="btn primary">提醒付款</div>
                    <div v-if="detail.status_text === 'wait_delivery' && detail.goods.some(item=>item.delivery_mode == 1)" class="btn primary logistics" @click="onOrderShipped(detail)">发货</div>
                    <div v-if="detail.status_text === 'wait_delivery' && detail.goods.every(item=>Number(item.delivery_mode) === 0)" class="order-detail-btn">商品由平台发货</div>
                    <div v-if="detail.status_text === 'wait_delivery' && detail.goods.some(item=>item.delivery_mode != 1) && detail.goods.some(item=>item.delivery_mode == 1)" class="order-detail-btn">
                        部分商品平台发货
                    </div>
                    <div v-if="detail.status_text === 'wait_confirm'" class="btn primary logistics" @click="show_logistics = true">查询物流</div>
                    <div v-if="['wait_delivery','wait_pay'].includes(detail.status_text) && false" class="btn info">修改发货地址</div>
                    <div v-if="detail.delivery_mode == 0 && false" class="btn info">查看提交代发详情</div>
                </div>
            </div>
            <!-- 已发货订单：发货记录列表，提供修改物流入口 -->
            <div v-if="['wait_confirm','service'].includes(detail.status_text) && (detail.deliveries && detail.deliveries.length)" class="delivery-records">
                <div class="delivery-records-title">发货记录</div>
                <table>
                    <thead>
                        <tr>
                            <th>物流公司</th>
                            <th>运单号</th>
                            <th>发货时间</th>
                            <th>备注</th>
                            <th width="180">操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(d, di) in detail.deliveries" :key="di">
                            <td>{{ d.logistics_name || '-' }}</td>
                            <td>{{ d.logistics_no || '-' }}</td>
                            <td>{{ d.send_time || '-' }}</td>
                            <td :title="d.memo">{{ d.memo || '-' }}</td>
                            <td>
                                <div class="record-actions">
                                    <div class="op-btn" @click="onOpenModifyLogistics(d)">修改物流</div>
                                    <div class="op-btn primary" @click="onQueryLogistics(d)">查询物流</div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="order-info-box">
                <div class="order-info-left">
                    <div class="order-info-title">订单信息</div>
                    <div class="order-info-list">
                        <div class="order-info-item">
                            <div class="label">订单编号：</div>
                            <div class="value">{{detail.order_no}}</div>
                        </div>
                        <div class="order-info-item">
                            <div class="label">下单时间：</div>
                            <div class="value">{{detail.create_time}}</div>
                        </div>
                        <div class="order-info-item">
                            <div class="label">付款时间：</div>
                            <div class="value">{{detail.pay_time || '-'}}</div>
                        </div>
                        <div class="order-info-item">
                            <div class="label">发货方式：</div>
                            <div class="value">包邮</div>
                        </div>
                        <div class="order-info-item">
                            <div class="label">支付方式：</div>
                            <div class="value">{{detail.pay_type_text}}</div>
                        </div>
                        <div class="order-info-item">
                            <div class="label">发货时间：</div>
                            <div class="value">{{detail.delivery_time || '-'}}</div>
                        </div>
                        <div class="order-info-item">
                            <div class="label">订单备注：</div>
                            <img v-if="detail.owner_memo" :src="detail.owner_flag|remark_filter" class="remark-label" alt="" />
                            <div class="value">{{ detail.owner_memo || '暂无备注' }}</div>
                            <div class="edit-btn" @click="show_remark = true">
                                <img src="@/assets/images/shop-manage/icon-shop-order-remark-edit.png" alt="" class="edit-icon" />{{ detail.owner_memo ? '修改' : '添加' }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="buyer-info">
                    <div class="buyer-info-title">买家信息</div>
                    <div class="buyer-info-item">
                        <div class="buyer-label">买家昵称：</div>
                        <div class="buyer-value">{{order.member && (order.member.nickname || detail.contact_person)}}</div>
                        <img v-if="userInfo.id !=  (order.member && order.member.id)" src="@/assets/images/shop-manage/icon-shop-order-service.png" @click="onChatClick(order.member)" alt="" class="service-icon">
                    </div>
                    <div class="buyer-info-item align-start">
                        <div class="buyer-label">收货信息：</div>
                        <div class="buyer-value">
                            {{detail.contact_person}},{{detail.contact_mobile}},{{`${detail.province}${detail.city}${detail.zone}${detail.address}`}}
                        </div>
                        <div class="edit-address-btn" @click="onEditAddress">修改地址</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="order-products-info">
            <div class="order-products-info-title">商品信息</div>
            <table>
                <thead>
                    <tr>
                        <th>商品信息</th>
                        <th>单价</th>
                        <th>数量</th>
                        <th>运费</th>
                        <!-- <th>售后状态</th> -->
                        <th>订单状态</th>
                        <!-- <th>操作</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(product,index) in detail.goods" :key="index">
                        <td>
                            <div class="item-product-col" >
                                <img :src="product.product_image|default_img" alt="" class="product-cover" />
                                <div class="name-spec-box">
                                    <div class="name">{{product.product_name}}</div>
                                    <div class="spec">{{product.spec_info}}</div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="item-price-col">
                                <span>¥{{product.price}}</span>
                                <span>¥{{product.tag_price}}</span>
                            </div>
                        </td>
                        <td>
                            <div class="item-num-col">
                                <span>x{{product.quantity}}</span>
                            </div>
                        </td>
                        <td>
                            <div class="item-price-col">
                                <span>¥{{product.freight || 0}}</span>
                            </div>
                        </td>
                        <td>
                            <div class="item-order-status-col">
                                <div class="order-status">
                                    <div :class="onGetStatusClass(detail.status_text)">
                                        {{ detail.status_name }} <span v-if="detail.delivery_mode == 0">(工厂代发)</span>
                                    </div>
                                </div>
                                <div v-if="detail.status_text === 'wait_confirm'" class="logistics" @click="show_logistics = true">查询物流</div>
                                <div v-if="false" class="apply-time">
                                    <span>申请时间</span>
                                    <span>2025-08-08 08:08</span>
                                </div>
                            </div>
                        </td>
                        <!-- <td>
                            <div class="item-operation-col">
                                <div v-if="detail.status_text === 'wait_delivery'" class="order-send">发货</div>
                                <div class="contact-service">联系工厂客服</div>
                                <div class="apply-order">审核通过</div>
                                <div class="reject-order">驳回申请</div>
                                <div class="confirm-recive">确认收货</div>
                                <div class="fill-logistics-info" title="填写发货信息">填写发货信息</div>
                                <div class="order-detail-btn">售后详情</div>
                            </div>
                        </td> -->
                    </tr>
                </tbody>
            </table>
            <div class="price-box">
                <div class="price-item">
                    <div class="item-label">总金额：</div>
                    <div class="item-value">¥{{detail.total_price}}</div>
                </div>
                <div class="price-item">
                    <div class="item-label">运费：</div>
                    <div class="item-value">¥{{detail.freight}}</div>
                </div>
                <div class="price-item">
                    <div class="item-label">实收总额：</div>
                    <div class="item-value total-price">¥{{total}}</div>
                </div>
            </div>
        </div>
        <order-remark v-if="show_remark" :order="detail" @close="show_remark=false" @on-remarked="onGetOrderDetail"></order-remark>
        <chat ref="chat"></chat>
        <logistics-tracking-dialog v-if="show_logistics" :order="detail" @close="show_logistics=false"></logistics-tracking-dialog>
        <modify-address ref="modify_address" @saved="onAddressSaved"></modify-address>
        <modify-logistics v-if="show_modify_logistics" :order="detail" :delivery="curr_delivery" @close="onCloseModifyLogistics" @revised="onLogisticsRevised"></modify-logistics>
    </div>
</template>
<script>
import { shopOrderDetail } from '@/api/index';
import { mapState } from 'vuex';
import LogisticsTrackingDialog from './LogisticsTrackingDialog.vue';
import ModifyAddress from './ModifyAddress.vue';
import ModifyLogistics from './ModifyLogistics.vue';
import OrderRemark from './OrderRemark.vue';
export default{
    name:"OrderDetail",
    components:{
        OrderRemark,
        LogisticsTrackingDialog,
        ModifyAddress,
        ModifyLogistics,
    },
    props:{
        order:{type:Object,default:()=>{}}
    },
    data(){
        return{
            detail:{},
            uuid:'',
            show_remark:false,
            show_logistics:false,
            // 已发货订单修改物流
            show_modify_logistics:false,
            curr_delivery:{},
        }
    },
    filters:{
        remark_filter(value){
            switch(value){
                case 'green':
                    return require('@/assets/images/shop-manage/icon-shop-order-remark-green.png');
                case 'blue':
                    return require('@/assets/images/shop-manage/icon-shop-order-remark-blue.png');
                case 'red':
                    return require('@/assets/images/shop-manage/icon-shop-order-remark-red.png');
                case 'yellow':
                    return require('@/assets/images/shop-manage/icon-shop-order-remark-yellow.png');
                default:
                    return require('@/assets/images/shop-manage/icon-shop-order-remark-empty.png');
            }
        },
    },
    computed:{
         ...mapState({
            userInfo:state=>state.userInfo,
        }),
        total(){
            const {total_price,freight,discount} = this.detail;
            return (parseFloat(total_price) + parseFloat(freight) - parseFloat(discount)).toFixed(2);
        },
        activeService(){
            if(!this.detail.goods) return null;
            const goods = this.detail.goods.find(g => g.service && !['complete','cancel'].includes(g.service.status_text));
            return goods ? goods.service : null;
        },
        steps(){
            const {detail} = this;
            return [
            {
                title: '买家下单',
                time: detail.create_time,
                dot_active: !!detail.create_time, // 如果创建时间存在，则激活
                line_active: !!detail.create_time // 如果创建时间存在，则连线激活
            },
            {
                title: '买家付款',
                time: detail.pay_time,
                dot_active: !!detail.pay_time, // 如果付款时间存在，则激活
                line_active: !!detail.pay_time && !!detail.create_time // 如果付款时间和创建时间都存在，则连线激活
            },
            {
                title: '卖家发货',
                time: detail.delivery_time,
                dot_active: !!detail.delivery_time, // 如果发货时间存在，则激活
                line_active: !!detail.delivery_time && !!detail.pay_time // 如果发货时间和付款时间都存在，则连线激活
            },
            {
                title: '交易成功',
                time: detail.complete_time,
                dot_active: !!detail.complete_time, // 如果完成时间存在，则激活
                line_active: !!detail.complete_time && !!detail.delivery_time // 如果完成时间和发货时间都存在，则连线激活
            }
            ];
        }
    },
    watch: {
        show_logistics(val) {
            document.body.style.overflow = val ? 'hidden' : '';
        },
        show_modify_logistics(val) {
            document.body.style.overflow = val ? 'hidden' : '';
        }
    },
    mounted(){
        console.log('order',this.order);    
        this.uuid = this.order.uuid;
        this.onGetOrderDetail();
    },
    methods:{
        onOrderShipped(order){
            this.$emit('shipped',order);
        },
        onChatClick(user){
            this.$refs["chat"].showChat(null, user);
        },
        async onGetOrderDetail(){
            try{
                const {uuid} = this;
                console.log('uuid',uuid);
                const {code,msg,data} = await shopOrderDetail({uuid});
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('data-detail',data);
                this.detail = data;
            }catch(e){
                console.log('err-order-detail',e);
                this.$layer.msg(e.msg);
            }
        },
        // 已发货订单打开修改物流（由发货记录行的「修改物流」触发）
        onOpenModifyLogistics(delivery){
            if(!delivery || !delivery.id){
                this.$layer.msg('暂无可修改的发货记录');
                return;
            }
            this.curr_delivery = delivery;
            this.show_modify_logistics = true;
        },
        onCloseModifyLogistics(){
            this.show_modify_logistics = false;
            this.curr_delivery = {};
        },
        // 修改物流成功后局部更新发货包并刷新详情
        onLogisticsRevised(delivery){
            const list = this.detail.deliveries;
            if(Array.isArray(list)){
                const idx = list.findIndex(d => d.id === delivery.delivery_id || d.id === delivery.id);
                if(idx >= 0){
                    this.$set(this.detail.deliveries, idx, {
                        ...list[idx],
                        logistics_id: delivery.logistics_id,
                        logistics_no: delivery.logistics_no,
                        memo: delivery.memo
                    });
                }
            }
            this.onGetOrderDetail();
        },
        // 查看包裹物流轨迹
        onQueryLogistics(delivery){
            // 选中当前发货记录后弹出查询物流弹窗（沿用 show_logistics）
            if(delivery){
                this.curr_delivery = delivery;
            }
            this.show_logistics = true;
        },
        onOrderListClick(){
            this.$emit('order-list');
        },
        onEditAddress(){
            this.$nextTick(()=>{
                this.$refs.modify_address.showEdit(this.detail);
            });
        },
        onAddressSaved(){
            this.onGetOrderDetail();
        },
        onServiceDetail(){
            if(this.activeService){
                this.$emit('service-detail', this.activeService);
            }
        },
        onGetStatusClass(val){
            switch(Number(val)){
                case 6:
                    return 'finish';
                case 5:
                    return 'exchange';
                case 2:
                    return 'wait-recive';
                case 1:
                case 3:
                case 4:
                    return 'wait-send';
                default:
                    return 'not-pay';
            }
        },
    }
}
</script>
<style lang="scss" scoped>
    .order-detail{
        display:flex;
        flex-direction:column;
        margin-top:22px;
        user-select:none;
        .bread-crumbs{
            display:flex;
            align-items:center;
            column-gap:8px;
            .bread-crumbs-item{
                color:#999999;
                font-size:14px;
                cursor:pointer;
                &:hover,&.active{
                    color:#333333;
                }
            }
        }
        .order-info{
            width:100%;
            background:#ffffff;
            padding:0 30px;
            display:flex;
            flex-direction:column;
            margin-top:19px;
            .order-step-box {
                width:100%;
                display:flex;
                justify-content:center;
                align-items:center;
                margin-top:28px;
                border-bottom:1px solid #d6d6d6;
                .order-step-info{
                    $order-red:#ff4d4f;
                    $line-gray:#e5e5e5;
                    $text-gray:#999;
                    display:flex;
                    align-items:flex-start;
                    justify-content:space-between;
                    padding:0 10px 20px 10px;
                    .order-step-item{
                         display:flex;
                         flex-direction:column;
                         align-items:center;
                         justify-content:center;
                         position:relative;
                         width:151px;
                         .line{
                            width:calc(100% - 9px);
                            height:1px;
                            background:#e3e3e3;
                            position:absolute;
                            top:4px;
                            left:-47%;
                            &.active{
                                background:$order-red;
                            }
                         }
                         .dot-info-box{
                            display:flex;
                            flex-direction:column;
                            align-items:center;
                            justify-content:center;
                            .dot{
                                width:9px;
                                height:9px;
                                border:1px solid #e3e3e3;
                                border-radius:50%;
                                &.active{
                                    background:$order-red;
                                    border-color:$order-red;
                                }
                            }
                            .title{
                                color:#333;
                                font-size:14px;
                                margin-top:11px;
                            }
                            .time{
                                color:#999;
                                font-size:12px;
                                margin-top:3px;
                            }
                         }
                    }
                }
            }
            .order-status-box{
                width:100%;
                display:flex;
                flex-direction:column;
                margin-top:29px;
                padding-bottom:32px;
                border-bottom:1px solid #d6d6d6;
                .status-text{
                    display:flex;
                    align-items:center;
                    column-gap:8px;
                    .label{
                        color:#333333;
                        font-size:13px;
                    }
                    .value{
                        color:#ff5000;
                        font-size:18px;
                        font-weight:bold;
                    }
                    .service-btn{
                        height:28px;
                        line-height:28px;
                        padding:0 14px;
                        margin-left:16px;
                        border-radius:4px;
                        background:#ff5967;
                        color:#fff;
                        font-size:13px;
                        cursor:pointer;
                    }
                }
                .btn-box{
                    display:flex;
                    column-gap:16px;
                    margin-top:33px;
                    .btn{
                        width:fit-content;
                        height:32px;
                        line-height:32px;
                        border-radius:4px;
                        font-size:14px;
                        padding:0 12px;
                        &.primary{
                            background:#ff5967;
                            color:#fff;
                            &.logistics{
                                padding:0 26px;
                            }
                        }
                        &.info{
                            background:#fff;
                            color:#666;
                            border:1px solid #b3b3b3;
                        }
                    }
                }
            }
            .order-logistics-box{
                width:100%;
                display:flex;
                flex-direction:column;
                margin-top:16px;
                padding-bottom:36px;
                border-bottom:1px solid #d6d6d6;
                .logistics-top{
                    width:100%;
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    .top-left{
                        display:flex;
                        align-items:center;
                        column-gap:20px;
                        .logistics-top-icon{
                            width:64px;
                            height:64px;
                        }
                        .logistics-top-status{
                            display:flex;
                            column-gap:12px;
                            align-items:center;
                            .logistics-top-text{
                                color:#333;
                                font-size:16px;
                            }
                            .logistics-top-line{
                                color:#e3e3e3;
                                font-size:20px;
                            }
                            .logistics-status{
                                color:#02c160;
                                font-size:16px;
                                font-weight:bold;
                            }
                        }
                    }
                    .top-right{
                        color:#666;
                        font-size:14px;
                    }
                }
                .logistics-package-list{
                    width:100%;
                    display:flex;
                    align-items:center;
                    column-gap:10px;
                    margin-top:16px;
                    .package-item{
                        color:#666;
                        font-size:16px;
                        height:32px;
                        line-height:32px;
                        padding:0 30px;
                        border-radius:16px;
                        border:1px solid #e3e3e3;
                        cursor:pointer;
                        &:hover, &.active{
                            color:#333;
                            border:1px solid #b3b3b3;
                        }
                    }
                }
                .logistics-info-box{
                    width:100%;
                    height:400px;
                    background:#f9fafc;
                    border-radius:10px;
                    margin-top:20px;
                    padding:30px 0 30px 40px;
                    display:flex;
                    column-gap:182px;
                    .logistics-info-left{ 
                        display:flex;
                        flex-direction:column;
                        width:230px;
                        .logistics-img{
                            width:230px;
                            height:130px;
                        }
                        .logistics-info-title{
                            color:#333;
                            font-size:18px;
                            margin-top:32px;
                            margin-bottom:32px;
                        }
                        .logistics-info-content{
                            display:flex;
                            flex-direction:column;
                            row-gap:11px;
                            .logistics-info-item{ 
                                display:flex;
                                align-items:center;
                                .label{
                                    color:#333;
                                    font-size:14px;
                                }
                                .value{
                                    color:#333;
                                    font-size:14px;
                                }
                            }
                        }
                    }
                    .logistics-info-right{
                        flex:0 0 70%;
                        height:100%;
                        overflow-y:auto;
                        &::-webkit-scrollbar-track {
                            background: transparent; /* 滚动条轨道背景 */
                            border-radius: 4px;
                        }
                        &::-webkit-scrollbar-button {
                            display: none !important; /* 隐藏滚动条的上下箭头按钮 */
                        }
                        .logistics-router-box{
                            width:100%;
                            display:flex;
                            flex-direction:column;
                            margin-top:10px;
                            .logistics-router-item{
                                width:100%;
                                min-height:30px;
                                display:flex;
                                align-items:flex-start;
                                column-gap:24px;
                                line-height:17px;
                                .router-item-left{
                                    color:#666;
                                    font-size:12px;
                                    &.active{
                                        color:#000;
                                    }
                                }
                                .router-item-center{
                                    width:10px;
                                    height:10px;
                                    background:#c9c9c9;
                                    border-radius:50%;
                                    position:relative;
                                    z-index:1;
                                    &.active{
                                        background:#ff5967;
                                        box-shadow:0 0 0 2.5px #ff5967;
                                    }
                                    &::after{
                                        position:absolute;
                                        content:'';
                                        width:2px;
                                        // height:30px;
                                        background:#c9c9c9;
                                        height:1px;
                                        padding-bottom:35px;
                                        left:40%;
                                        top:6px;
                                        z-index:0;
                                    }
                                }
                                .router-item-right{
                                    display:flex;
                                    flex-direction:column;
                                    row-gap:4px;
                                    .status{
                                        color:#ff5967;
                                        font-size:14px;
                                        font-weight:bold;
                                    }
                                    .status-desc{
                                        color:#666;
                                        font-size:12px;
                                        padding-bottom:24px;
                                        &.active{
                                            color:#333;
                                        }
                                    }
                                }

                                &:first-child{
                                    .router-item-center{
                                        &::after{
                                            padding-bottom:50px;
                                            top:13.5px;   
                                        }
                                    }
                                }
                                &:last-child{
                                    .router-item-center{
                                        &::after{
                                            display:none !important;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                .logistics-products-list-title{
                    color:#666;
                    font-size:14px;
                    margin-top:25px;
                }
                .logistics-products-list{
                    width:100%;
                    display:flex;
                    flex-wrap:wrap;
                    gap:10px;
                    margin-top:24px;
                    .products-item{
                        flex:0 0 calc((100% - 30px) / 3);
                        min-width:300px;
                        max-width:500px;
                        border:1px solid #e3e3e3;
                        border-radius:10px;
                        padding:16px;
                        display:flex;
                        column-gap:16px;
                        align-items:center;
                        .products-cover{
                            width:96px;
                            height:96px;
                            border:1px solid #e3e3e3;
                            border-radius:8px;
                        }
                        .title-spec-num{
                            display:flex;
                            flex-direction:column;
                            row-gap:14px;
                            flex:1;
                            .title{
                                width:100%;
                                color:#333;
                                font-size:14px;
                                display:-webkit-box;
                                line-clamp:2;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient:vertical;
                                overflow:hidden;
                                text-overflow:ellipsis;
                                word-break:break-all;
                            }
                            .spec-num{
                                display:flex;
                                column-gap:24px;
                                .spec{
                                    display:flex;
                                    column-gap:10px;
                                    font-size:14px;
                                    .color{
                                        color:#666;
                                    }
                                    .size{
                                        color:#666;
                                    }
                                }
                                .num{
                                    font-size:14px;
                                    color:#666;
                                }
                            }
                        }
                    }
                }
            }
            .delivery-records{
                width:100%;
                padding:20px 0 32px 0;
                border-bottom:1px solid #d6d6d6;
                .delivery-records-title{
                    color:#333;
                    font-size:16px;
                    margin-bottom:14px;
                }
                table{
                    width:100%;
                    border-collapse:collapse;
                    table-layout:fixed;
                    thead{
                        tr{
                            background:#f6f7fa;
                            th{
                                height:42px;
                                color:#666;
                                font-size:13px;
                                text-align:center;
                            }
                        }
                    }
                    tbody{
                        tr{
                            td{
                                padding:14px 8px;
                                color:#333;
                                font-size:14px;
                                text-align:center;
                                border-bottom:1px solid #f0f1f4;
                                .record-actions{
                                    display:flex;
                                    align-items:center;
                                    justify-content:center;
                                    column-gap:14px;
                                    .op-btn{
                                        color:#0066ff;
                                        font-size:13px;
                                        cursor:pointer;
                                        &.primary{
                                            color:#ff5967;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            .order-info-box{
                width:100%;
                display:flex;
                column-gap:45px;
                margin-top:25px;
                .order-info-left{
                    flex:0 0 60%;
                    display:flex;
                    flex-direction:column;
                    margin-bottom:17px;
                    .order-info-title{
                        color:#333;
                        font-size:16px;
                        width:100%;
                        margin-bottom:17px;
                    }
                    .order-info-list{
                        width:100%;
                        display:flex;
                        flex-wrap:wrap;
                        row-gap:13px;
                        .order-info-item{
                            flex:0 0 50%;
                            font-size:14px;
                            display:flex;
                            align-items:flex-start;
                            .label{
                                color:#666;
                                flex-shrink:0;
                            }
                            .value{
                                color:#666;
                                &:nth-last-of-type{
                                    white-space:nowrap;
                                    text-overflow:ellipsis;
                                    overflow:hidden;
                                }
                            }
                            .remark-label{
                                width:22px;
                                height:22px;
                            }
                            .edit-btn{
                                display:flex;
                                align-items:center;
                                flex-shrink:0;
                                color:#999;
                                font-size:13px;
                                margin-left:16px;
                                cursor:pointer;
                                .edit-icon{
                                    width:20px;
                                    height:20px;
                                }
                            }
                            &:last-child{
                                flex:0 0 100%;
                            }
                        }
                    }
                }
                .buyer-info{
                    flex:0 0 40%;
                    display:flex;
                    flex-direction:column;
                    .buyer-info-title{
                        color:#333;
                        font-size:16px;
                        margin-bottom:17px;
                    }
                    .buyer-info-item{
                        display:flex;
                        align-items:center;
                        margin-bottom:13px;
                        font-size:14px;
                        &.align-start{
                            align-items:start;
                        }
                        .buyer-label{
                            color:#666;
                            flex-shrink:0;
                        }
                        .buyer-value{
                            color:#666;
                        }
                        .service-icon{
                            width:22px;
                            height:22px;
                            margin-left:14px;
                            cursor:pointer;
                        }
                        .edit-address-btn{
                            flex-shrink:0;
                            color:#0066ff;
                            font-size:12px;
                            margin-left:14px;
                            cursor:pointer;
                        }
                    }
                }
            }
        }
        .order-products-info{
            width:100%;
            background:#fff;
            padding:25px 30px 50px 30px;
            margin-top:16px;
            .order-products-info-title{
                color:#333;
                font-size:16px;
            }
            table{
                width:100%;
                border-collapse: separate;
                border-spacing: 0;
                table-layout:fixed;
                margin-top:17px;
                thead tr{
                    text-align:center;
                    height:52px;
                    th{
                        background:#f6f7fa;
                        color:#666;
                        border-top:1px solid #ebedf2;
                        &:first-child{
                            border-left:1px solid #ebedf2;
                            border-top-left-radius:9px;
                            width:40%;
                        }
                        &:last-child{
                            border-right:1px solid #ebedf2;
                            border-top-right-radius:9px;
                        }
                    }
                }
                tbody tr{
                    &:last-child{
                        td{
                            &:first-child{
                                border-bottom-left-radius:10px;
                            }
                            &:last-child{
                                border-bottom-right-radius:10px;
                            }
                        }
                    }
                    td{
                        border-bottom:1px solid #ebedf2;
                        &:first-child{
                            border-left:1px solid #ebedf2;
                        }
                        &:last-child{
                            border-right:1px solid #ebedf2;
                        }
                        .item-product-col{
                            flex:0 0 40%;
                            display:flex;
                            column-gap:16px;
                            padding:20px;
                            .product-cover{
                                width:96px;
                                height:96px;
                                border-radius:8px;
                                object-fit:cover;
                            }
                            .name-spec-box{
                                flex:1;
                                display:flex;
                                flex-direction:column;
                                row-gap:11px;
                                margin-top:9px;
                                .name{
                                    width:100%;
                                    white-space:nowrap;
                                    overflow:hidden;
                                    text-overflow:ellipsis;
                                    color:#333333;
                                    font-size:14px;
                                }
                                .spec{
                                    color:#666666;
                                    font-size:14px;
                                    white-space:nowrap;
                                    overflow:hidden;
                                    text-overflow:ellipsis;
                                }
                            }
                        }
                        .item-price-col,.item-num-col{
                            flex:0 0 10%;
                            display:flex;
                            flex-direction:column;
                            align-items:center;
                            span{
                                color:#808080;
                                &:first-child{
                                    color:#333333;
                                    font-size:14px;
                                }
                                &:nth-child(2){
                                    font-size:12px;
                                    text-decoration: line-through;
                                }
                                &:last-child{
                                    font-size:13px;
                                }
                            }
                        }
                        .item-after-sale-col{
                            // flex:0 0 10%;
                            display:flex;
                            flex-direction:column;
                            // align-items:center;
                            justify-content:center;
                            .empty{
                                width:100%;
                                text-align:center;
                            }
                            .after-sale-type{
                                width:100%;
                                display:flex;
                                align-items:center;
                                font-size:14px;
                                .label{
                                    color:#666666;
                                }
                                .value{
                                    color:#ff0016;
                                }
                            }
                            span{
                                font-size:12px;
                                color:#666666;
                                white-space:nowrap;
                                overflow:hidden;
                                text-overflow:ellipsis;
                                text-align:left;
                            }
                            .voucher-box{
                                display:flex;
                                align-items:center;
                                column-gap:6px;
                                color:#0d99ff;
                                font-size:12px;
                                cursor:pointer;
                                .voucher-icon{
                                    width:20px;
                                    height:20px;
                                }
                            }
                        }
                        .item-order-status-col{
                            flex:0 0 10%;
                            display:flex;
                            flex-direction:column;
                            align-items:center;
                            justify-content:center;
                            .order-status{
                                font-size:14px;
                                color:#999999;
                                white-space:nowrap;
                                text-overflow:ellipsis;
                                overflow:hidden;
                                .finish{
                                    color:#666666;
                                }
                                .exchange{
                                    color:#0d99ff;
                                }
                                .wait-send,.check,.exchange-not-back{
                                    color:#ff5000;
                                }
                                .wait-recive{
                                    color:#02c160;
                                }
                                .not-pay{
                                    color:#333333;
                                }
                            }
                            .logistics{
                                display:flex;
                                align-items:center;
                                column-gap:8px;
                                color:#333333;
                                font-size:14px;
                                cursor:pointer;
                                &::after{
                                    content:"";
                                    background:#ff5967;
                                    width:6px;
                                    height:6px;
                                    border-radius:50%;
                                }
                            }
                            .apply-time{
                                display:flex;
                                flex-direction: column;
                                align-items: center;
                                color:#666666;
                                font-size:12px;
                            }
                        }
                        .item-operation-col{
                            display:flex;
                            flex-direction:column;
                            row-gap:8px;
                            align-items:center;
                            justify-content:center;
                            .order-detail-btn{
                                color:#333333;
                                font-size:14px;
                                cursor:pointer;
                            }
                            .order-send,
                            .contact-service,
                            .reject-order,
                            .confirm-recive,
                            .fill-logistics-info,
                            .apply-order{
                                height:28px;
                                font-size:14px;
                                border-radius:4px;
                                color:#ffffff;
                                text-align:center;
                                line-height:28px;
                                padding:0 8px;
                                cursor:pointer;
                            }
                            .order-send,
                            .contact-service,
                            .reject-order,
                            .confirm-recive,
                            .fill-logistics-info{
                                background:#ff5967;
                            }
                            .apply-order{
                                background:#02c160;
                            }
                            .order-send{
                                width:72px;
                            }
                        }
                    }
                }
            }
            .price-box{
                width:100%;
                display:flex;
                flex-direction:column;
                align-items:flex-end;
                margin-top:13px;
                .price-item{
                    display:flex;
                    align-items:center;
                    margin-top:12px;
                    &:last-child{
                        margin-top:18px;
                    }
                    .item-label{
                        color:#666;
                        font-size:14px;
                    }
                    .item-value{
                        color:#333;
                        font-size:16px;
                        min-width:128px;
                        text-align:right;
                        &.total-price{
                            color:#ff5967;
                            font-size:20px;
                            font-weight:bold;
                        }
                    }
                }
            }
        }
    }
    @media screen and (min-width: 1280px) and (max-width: 1679px) {
    .order-detail {
        .order-info {
            .order-step-box {
                .order-step-info {
                    .order-step-item {
                        width: 120px; // 缩小步骤项宽度
                        .time {
                            font-size: 11px; // 缩小字体
                        }
                    }
                }
            }
            
            .order-logistics-box {
                .logistics-info-box {
                    column-gap: 100px; // 减少左右间距
                    
                    .logistics-info-left {
                        width: 180px; // 调整左侧宽度
                        
                        .logistics-img {
                            width: 180px;
                            height: 100px;
                        }
                    }
                    
                    .logistics-info-right {
                        flex: 0 0 65%; // 调整右侧比例
                    }
                }
                
                .logistics-products-list {
                    .products-item {
                        flex: 0 0 calc((100% - 20px) / 2); // 两列布局
                        min-width: 250px;
                        
                        .title {
                            font-size: 13px; // 缩小字体
                        }
                    }
                }
            }
            
            .order-info-box {
                column-gap: 20px; // 减少左右间距
                
                .order-info-left {
                    flex: 0 0 65%; // 调整比例
                    
                    .order-info-item {
                        flex: 0 0 50%;
                        
                        &:last-child {
                            flex: 0 0 100%;
                        }
                    }
                }
                
                .buyer-info {
                    flex: 0 0 35%; // 调整比例
                }
            }
        }
        
        .order-products-info {
            table {
                tbody tr {
                    td {
                        .item-product-col {
                            .name-spec-box {
                                .name {
                                    font-size: 13px; // 缩小字体
                                }
                            }
                        }
                        
                        .item-price-col, .item-num-col {
                            span {
                                font-size: 12px; // 缩小字体
                            }
                        }
                    }
                }
            }
        }
    }
}
</style>